// api/research-campaigns.ts — Research → Campaigns (research track R1–R3). The backend's /api/research/campaigns routes;
// the shapes are contracts' (TYPE-only imports: nothing from @vms/contracts reaches the bundle).
import type {
  CampaignSummary, ResearchCampaign, ResearchCampaignScreen, CampaignKeyword, ResearchCampaignCreate,
  CampaignLaunchResult, ResearchPromoteResult, ItemPromoteResult, ResearchCraftKind,
} from "@vms/contracts";
import { apiGet, apiPost } from "./client.ts";

const BASE = "/research/campaigns";
export type NewCampaign = Omit<ResearchCampaignCreate, "createdBy">;   // the actor is the signed-in operator (server-side)

export const researchCampaignsApi = {
  list: () => apiGet<{ campaigns: CampaignSummary[] }>(BASE),
  create: (c: NewCampaign) => apiPost<{ campaign: ResearchCampaign }>(BASE, c),
  /** THE composition read — every count on the screen. */
  screen: (id: string) => apiGet<ResearchCampaignScreen>(`${BASE}/${id}`),
  generate: (id: string) => apiPost<{ campaign: ResearchCampaign }>(`${BASE}/${id}/generate`, {}),
  saveKeywords: (id: string, keywords: CampaignKeyword[]) => apiPost<{ campaign: ResearchCampaign }>(`${BASE}/${id}/keywords`, { keywords }),
  launch: (id: string) => apiPost<CampaignLaunchResult>(`${BASE}/${id}/launch`, {}),
  pause: (id: string) => apiPost<{ changed: number; status: string }>(`${BASE}/${id}/pause`, {}),
  resume: (id: string) => apiPost<{ changed: number; status: string }>(`${BASE}/${id}/resume`, {}),
  revisit: (id: string) => apiPost<{ creators: number; until: string }>(`${BASE}/${id}/revisit`, {}),
  promote: (id: string, teardownJobId: string, crafts: Array<{ kind: ResearchCraftKind; shotIndex: number | null }>) =>
    apiPost<ResearchPromoteResult>(`${BASE}/${id}/promote`, { teardownJobId, crafts }),
  curate: (id: string, itemId: string, reason: string) => apiPost<ItemPromoteResult>(`${BASE}/${id}/curate/${itemId}`, { reason }),
  reproduceGoal: (id: string, businessRef: string, presetId: string, goal?: string) =>
    apiPost<{ runId: string }>(`${BASE}/${id}/reproduce/goal`, { businessRef, presetId, ...(goal ? { goal } : {}) }),
};
